import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["button"];

    disable(event) {
        event.preventDefault(); // Empêche une soumission instantanée (optionnel si besoin)

        // Désactive le bouton
        this.buttonTarget.disabled = true;
        this.buttonTarget.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;

        // Soumettre le formulaire après un court délai
        this.buttonTarget.closest("form").submit();
    }
}